/*
    这个文件用于定义项目所使用的数据定义相关
*/
export default {
    /*
        类型枚举
    */

    // Tile 状态枚举
    TileStatusType: Object.freeze({
        S_1: 0,
        S_2: 1
    })

}